import {PermissionsStates} from '../../States';

const INITIAL_STATE = localStorage.getItem('permissionsReducer')
    ? JSON.parse(localStorage.getItem('permissionsReducer'))
    : '';

export const PermissionsReducer = (state = INITIAL_STATE, action) => {
    const {type, payload} = action;

    switch (type) {
    case PermissionsStates.DELETE:
        return null;
    case PermissionsStates.EXPIRE:
        return {reducer_status: PermissionsStates.EXPIRE};

    case PermissionsStates.SUCCESS:
        return {...payload, reducer_status: PermissionsStates.SUCCESS};

    case PermissionsStates.FAILED:
        return {...payload, reducer_status: PermissionsStates.FAILED};

    case PermissionsStates.RESET:
        return INITIAL_STATE;

    default:
        return state;
    }
};
